export class filtertag {
    public filter_name: string | null = null;
    public tag_id: string | null = null;
    public tag_name: string | null = null;
    public name: string | null = null;
}